const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBody(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 443,
    height: 480,
    viewBox: "0 0 443 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "TIJELO2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M166.3,300.4c-2.37,15.47,11.18,37.52,21.7,45.8,14.1,11.1,16.3,18.8,19.3,23.4,11.2,20.5,19.9,20.5,21,5.4,2.3-30.1,26.3-40.7,29.2-42.8s23.2,3.3,24.6-3.2c2.3-10.1-7.8-13.6-19.3-23.9-3.9-10.3-11-33.5-35.1-40.7C194.36,266.46,169.05,282.41,166.3,300.4Z",
    style: {
      fill: "#cc200a",
      stroke: "#000",
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeWidth: "1.414199948310852px",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.6,350.8c6.1,3.4,10.1,7.9,22.7,9.3",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 5.7133002281188965,
      strokeWidth: "1.3575999736785889px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204,358.9c8.2,18,20.5,26.9,20.3,22-2-36.2,29.4-47.8,26.9-47.6-1.7-3.2-29.4,1.8-33.3,33.4C215.9,367.2,204.7,357.9,204,358.9Z",
    style: {
      fillRule: "evenodd",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.3,323c19.4,7.3,38.1,5.2,35,1.9-23-24.9-28.5-31.3-14.7-5.7C261.6,320.9,243.5,321.8,243.3,323Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.5,305.2a11.41,11.41,0,0,0,12.9-4.7,14.51,14.51,0,0,0,1.3-6.5c-.3-8.7-9-14.2-14.5-12.6",
    style: {
      opacity: 0.1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBody);
export default __webpack_public_path__ + "static/media/body.71969c9e4ac0ed2be5f6bbdd02fe98cb.svg";
export { ForwardRef as ReactComponent };